import React from 'react'
import Grid from '../Grid'
import Block from '../Block'
import Project from '../Project'
import { useProjectsQuery, useExperienceQuery } from '../../querys'
import { Role } from '../Timeline/Timeline'
import { CurrentlyTitle } from './Currently.styles'

const Currently = () => {
  const projects = useProjectsQuery()
  const experience = useExperienceQuery()
  return (
    <Grid dColumns="2">
      <Block padded>
        <CurrentlyTitle>Currently at:</CurrentlyTitle>
        <Role key={experience[0].id} role={experience[0]} fullWidth />
      </Block>
      <Block padded>
        <CurrentlyTitle>Latest project:</CurrentlyTitle>
        <Project key={projects[0].id} project={projects[0]} />
      </Block>
    </Grid>
  )
}

export default Currently
